import { render } from "./ScrollGallerySection.vue?vue&type=template&id=94d6aa7e"
import script from "./ScrollGallerySection.vue?vue&type=script&lang=js"
export * from "./ScrollGallerySection.vue?vue&type=script&lang=js"

import "./ScrollGallerySection.vue?vue&type=style&index=0&id=94d6aa7e&lang=css"
script.render = render

export default script